import { useEffect } from 'react';
import { expVal } from '@atlassian/jira-feature-experiments';
import { useQueryParam, useRouter } from '@atlassian/react-resource-router';
import { useProjectBuilder } from '../../services/use-project-builder/index.tsx';

const CROSS_FLOW_SOURCE_QUERY_PARAM = 'source';
const CROSS_FLOW_SOURCE_VALUE = 'cross-flow';

const ProjectBuilderCrossFlowSourceTrigger = (): null => {
	const [sourceQueryParam, setSourceQueryParam] = useQueryParam(CROSS_FLOW_SOURCE_QUERY_PARAM);
	const [{ route }] = useRouter();
	const [, actions] = useProjectBuilder();

	useEffect(() => {
		if (
			sourceQueryParam === CROSS_FLOW_SOURCE_VALUE &&
			(route.name === 'servicedesk-queues-landing' ||
				route.name === 'servicedesk-getting-started-page')
		) {
			if (expVal('sequoia_jsmgrowth-219_bring_forwaed_request_types', 'isEnabled', false)) {
				actions.showProjectBuilder();
			}

			setSourceQueryParam(undefined);
		}
	}, [actions, sourceQueryParam, route.name, setSourceQueryParam]);

	return null;
};

export default ProjectBuilderCrossFlowSourceTrigger;
